import { createSlice } from "@reduxjs/toolkit";

export interface User {
  key?: string;
  roles?: string[];
  name?: string;
  organisationId?: string;
  forenames?: string;
  surname?: string;
}

const initialState: User = {};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(_state, action) {
      return action.payload;
    },
    updateUser(state, action) {
      return { ...state, ...action.payload };
    },
  },
});

export const { setUser, updateUser } = userSlice.actions;
export default userSlice.reducer;
